import React from "react";
import {
  Modal,
  Image,
  Text,
  Group,
  Space,
  Button,
  rem,
  Box,
} from "@mantine/core";

import { useTranslation } from "react-i18next";
import ringNotification from "assets/images/svgs/lpb/ring-notification.svg";
import Markdown from "react-markdown";

type NotificationPopupProps = {
  opened: boolean;
  close: () => void;
  title?: string;
  description?: string;
  closeModal?: () => void;
};

const NotificationPopup: React.FC<NotificationPopupProps> = ({
  opened,
  close,
  title,
  description = "",
  closeModal,
}) => {
  const { t } = useTranslation();
  const titleDefault = t("NOTIFICATION");
  return (
    <Modal
      opened={opened}
      onClose={() => {
        close();
        if (closeModal) {
          closeModal();
        }
      }}
      title=""
      centered
      closeOnClickOutside
    >
      <Group
        position="center"
        sx={{ display: "flex", flexDirection: "column" }}
      >
        <Image
          width={80}
          fit="contain"
          src={ringNotification}
          withPlaceholder
          alt="ad"
          key="ringNotification"
        />
        <Text align="center" fw={700} fz="xl">
          {title || titleDefault}
        </Text>
        {/* <Text align="center" fz="md" w="90%" c="dimmed">
          {description}
        </Text> */}
        <Box w="90%" style={{ textAlign: "center" }}>
          <Markdown>{description}</Markdown>
        </Box>
        <Space h={rem(5)} />
        {!closeModal && (
          <Group position="center">
            <Button
              color="primary"
              onClick={close}
              style={{ minWidth: rem(150) }}
            >
              {t("UNDERSTAND")}
            </Button>
          </Group>
        )}
        {closeModal && (
          <Group position="center">
            <Button
              color="primary"
              onClick={closeModal}
              style={{ minWidth: rem(150) }}
            >
              {t("CLOSE")}
            </Button>
          </Group>
        )}
        <Space h={rem(5)} />
      </Group>
    </Modal>
  );
};

export default NotificationPopup;
